<app-sidebar [userLogged]="userLogged"></app-sidebar>
<div class="feedback-container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="header">
      <h1 class="title">{{ 'feedback.header.title' | translate }}</h1>
    </div>

    <div class="content">
      <h2 class="text-center mb-4 feedback-title">{{ 'feedback.content.title' | translate }}</h2>

      <div class="mb-4">
        <label for="stars" class="form-label">{{ 'feedback.form.rating.label' | translate }}</label>
        <div class="rating">
          <div class="rating-row">
            <input type="radio" id="rating5" formControlName="stars" [value]="5" />
            <label for="rating5">★★★★★</label>
          </div>
          <div class="rating-row">
            <input type="radio" id="rating4" formControlName="stars" [value]="4" />
            <label for="rating4">★★★★☆</label>
          </div>
          <div class="rating-row">
            <input type="radio" id="rating3" formControlName="stars" [value]="3" />
            <label for="rating3">★★★☆☆</label>
          </div>
          <div class="rating-row">
            <input type="radio" id="rating2" formControlName="stars" [value]="2" />
            <label for="rating2">★★☆☆☆</label>
          </div>
          <div class="rating-row">
            <input type="radio" id="rating1" formControlName="stars" [value]="1" />
            <label for="rating1">★☆☆☆☆</label>
          </div>
        </div>
        <div
          *ngIf="
            form.get('stars')?.invalid && (form.get('stars')?.dirty || form.get('stars')?.touched)
          "
          class="text-danger mt-2"
        >
          <small *ngIf="form.get('stars')?.errors?.['required']">{{ 'feedback.form.rating.errors.required' | translate }}</small>
          <small *ngIf="form.get('stars')?.errors?.['starsRange']">{{ 'feedback.form.rating.errors.range' | translate }}</small>
        </div>
      </div>

      <div class="mb-4">
        <label for="comment" class="form-label">{{ 'feedback.form.comment.label' | translate }}</label>
        <textarea
          class="form-control mt-2"
          id="comment"
          formControlName="comment"
          rows="3"
          [placeholder]="'feedback.form.comment.placeholder' | translate"
        ></textarea>
      </div>

      <div class="buttons">
        <button type="submit" class="btn btn-save" [disabled]="form.invalid">
          {{ 'feedback.form.submit' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="onCancel()">{{ 'feedback.form.cancel' | translate }}</button>
      </div>
    </div>
  </form>
</div>
